import { Component, TemplateRef, Input, ViewChild } from "@angular/core";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "edp-popover",
    templateUrl: "./edp-popover.component.html",
    styleUrls: ["./edp-popover.component.scss"]
})
export class EdpPopoverComponent {
    @Input() popoverContent: TemplateRef<any>;
    @Input() popHeader: TemplateRef<any>;
    @Input() popBtn: string;
    @Input() popPlacement = "auto";
    @ViewChild("popover", { static: true }) public popover: NgbPopover;


    public closeManual(): void {
        this.popover.close();
    }

}
